
import React, { useState, useEffect } from "react";
import axios from "axios";
import PetCrateQuantity from "../../components/PetCrateQuantity/PetCrateQuantity";
import AddPetCrateQuantity from "../../components/AddPetCrateQuantity/AddPetCrateQuantity";
import PetCrateQuantityList from "../../components/PetCrateQuantityList/PetCrateQuantityList";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import PaginationLink from "../../components/Pagination/Pagination";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import "../../../src/App.css";

function PetCrateQuantityMaster() {
  const [userDetailResponse, setUserDetailResponse] = useState([]);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [filterCityData, setFilterCityData] = useState(false);
  const [RegionDetailResponse, setRegionDetailResponse] = useState([]);
  const [CrateQuantityResponse, setCrateQuantityResponse] = useState([]);
  const [crateSelObjQuantity, setCrateSelObjQuantity] = useState({});
  const [selectedCrate, setSelectedCrate] = useState(null);

    
  const [crateSelObj, setCrateSelObj] = useState(null); 

  const title = "Add Crate";
  const heading = "Pet Crate Quantity";
  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorage  ()  {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GetAllPetCrates?Crate_ID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setUserDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}Adminget/GETRegion?region_id=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setRegionDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching region details:", error);
        });

      axios
        .get(`${baseAPI}Adminget/GetAllPetCrateQuantity?Crate_Type_Id=&region_id=`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setCrateQuantityResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching crate quantities:", error);
        });
    }
  };


 
  useEffect(() => {
    tokenStorage();
  }, [successMessage, openAddProfile, setOpenProfile, openProfile, setOpenAddProfile]);

  const handleEditCrate = (crate) => {
    setSelectedCrate(crate);
    setOpenAddProfile(false);
    setOpenProfile(true);
  };

  const GetId = (obj) => {
    setCrateSelObjQuantity(obj);
  };


  const handleAddProfile = () => {
    setOpenProfile(false); 
    setOpenAddProfile(true);
  };

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div className="container-fluid" style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}>
        <div className="d-flex flex-column w-100" style={{ backgroundColor: "#F4F4F4" }}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Pet Crate Quantity Master | <HomeOutlinedIcon /> <span style={{ fontSize: "20px" }}>&gt; Pet Crate Quantity</span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA</option>
                <option value="1">DUBAI</option>
              </select>
            </div>
          </div>
          <Wrapper className="ViewLeadDetails">
            <MasterTopButtons
              title={title}
              heading={heading}
              setOpenAddProfile={setOpenAddProfile}
              openAddProfile={openAddProfile}
              setOpenProfile={setOpenProfile}
              setFilterCityData={setFilterCityData}
              setRegionDetailResponse={setRegionDetailResponse}
            />
            {openAddProfile && (
              <AddPetCrateQuantity
                tokenStorage={tokenStorage}
                openAddProfile={openAddProfile}
                setOpenAddProfile={setOpenAddProfile}
                successMessage={successMessage}
                setSuccessMessage={setSuccessMessage}
                userDetailResponse={userDetailResponse}
                RegionDetailResponse={RegionDetailResponse}
                CrateQuantityResponse={CrateQuantityResponse}
              />
            )}
            {openProfile && (
              <PetCrateQuantity
                tokenStorage={tokenStorage}
                openAddProfile={openAddProfile}
                setOpenAddProfile={setOpenAddProfile}
                successMessage={successMessage}
                setSuccessMessage={setSuccessMessage}
                userDetailResponse={userDetailResponse}
                CrateQuantityResponse={CrateQuantityResponse}
                crateSelObjQuantity={crateSelObjQuantity}
                crateSelObj={crateSelObj} 
                openProfile={openProfile}
                setCrateSelObj={setCrateSelObj} 
                setOpenProfile={setOpenProfile}
              />
            )}
            <PetCrateQuantityList
              userDetailResponse={userDetailResponse}
              CrateQuantityResponse={CrateQuantityResponse}
              setCrateSelObj={setCrateSelObj} 
              setOpenProfile={handleEditCrate}
              GetId={(param) => GetId(param)}
              refreshData={tokenStorage} 
            />
            <PaginationLink />
          </Wrapper>
        </div>
      </div>
    </div>
  );
}

export default PetCrateQuantityMaster;
